var map = {
	"./dianpu.svg": 4735,
	"./dinbgdan.svg": 7911,
	"./fenxaio.svg": 9767,
	"./goody.svg": 6608,
	"./guanli.svg": 9842,
	"./guanli1.svg": 8394,
	"./huodong.svg": 7120,
	"./man3.svg": 2964,
	"./moban.svg": 7445,
	"./paixu.svg": 6867,
	"./paixu2.svg": 6288,
	"./store.svg": 7559,
	"./vip.svg": 3885,
	"./zhijing.svg": 6415
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6611;